/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("pgcModifyDataModule", ["zoneServiceModule"]).
controller("pgcModifyDataCtrl", ["$scope", "$state", "editPictureService", "$element", "$validation", "zoneService", "httpService", "modalDialog", "Upload", "$q", function($scope, $state, editPictureService, $element, $validation, zoneService, httpService, modalDialog, Upload, $q) {
    initStatus();
    initData();

    function initStatus() {
        $scope.headPic = '';
        $scope.status = {
            sex: "",
            auditStatus: ''
        }
        $scope.info = {};
        $scope.data = {
            selectedArray: [], //选中的数据
            channelIds: []
        };
        $scope.listData = "";
    }

    function initData() {
        requestData();
        accessChannel();
        getPicSizeLimit();
    }
    /**
     * [requestData description] 产品列表查询
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        accessChannel().then(function() {
            requestData();
        })
    };
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/user/getLoginUser.do", "", "post").then(function(data) {
            $scope.info = data.loginUser;
            $scope.status.auditStatus = data.auditStatus;
            $scope.status.sex = data.loginUser.sex;
            $scope.info.introduction = data.loginUser.accountDesc;
            $scope.data.province = data.loginUser.province;
            $scope.data.city = data.loginUser.city;
            if (data.loginUser.logo) {
                $scope.headPic = angular.globalConfig.pictureServer + data.loginUser.logo;
            } else {
                $scope.headPic = './images/uperroe.png';
            }
            $scope.logo = data.loginUser.logo;
            if (data.loginUser.idNumberPic) {
                $scope.photoCard = angular.globalConfig.pictureServer + data.loginUser.idNumberPic;
                $scope.idNumberPic = data.loginUser.idNumberPic;
                $scope.status.photoCard = data.loginUser.idNumberPic;
            }

            for (var i = 0; i < data.signChannels.length; i++) {
                $scope.data.selectedArray.push(data.signChannels[i].id);
            }
        });
    };
    /**
     * [changeNumber description] 更换号码
     * @return {[type]} [description]
     */
    $scope.changeNumber = function() {
        zoneService.changeNumber($scope.status).then(function(data) {
            requestData()
        });
    };
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [changeHeadPortrait description]  更换头像
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeHeadPortrait = function(files, file, newFiles, item) {
        //不能是gif
        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'notice');
            return;
        }

        if (!file) return;
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        $scope.loadingPromise = uploadPic(newFiles).then(function(resp) {
            editPictureService.newCropperApp(angular.globalConfig.pictureServer + resp.data.url, "100,100").then(function(data) {
                var successInfo;
                var time = new Date().getTime();
                $scope.headPic = data.imgSrc + '?' + time;
                $scope.logo = data.imgSrc;
                successInfo = "头像修改成功";
            });
        });
    };
    /**
     * [uploadPic description] 上传图片
     * @return {[type]} [description]
     */
    function uploadPic(newFiles) {
        var deffer = $q.defer();
        Upload.upload({
            url: "/mcnww/upload/userLogo.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0]
            },
        }).then(function(resp) {
            if (!resp.data.success) {
                // modalDialog.alertType('', resp.data.message, "error", "confirm");
                modalDialog.success(resp.data.message, "success", false, function() {});
                deffer.reject(resp);
                return;
            }
            deffer.resolve(resp);
        });
        return deffer.promise;
    }
    /**
     * [changeidNumberPic description]  更换身份证
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeidNumberPic = function(files, file, newFiles, item) {
        //不能是gif
        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'notice');
            return;
        }
        if (!file) return;
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        Upload.upload({
            url: "/mcnww/upload/image.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0]
            },
        }).then(function(resp) {
            if (!resp.data.success) {
                modalDialog.success(resp.data.message, "success", false, function() {});
                return;
            }
            var time = new Date().getTime();
            var successInfo;
            $scope.photoCard = angular.globalConfig.pictureServer + resp.data.url + '?' + time;
            $scope.idNumberPic = resp.data.url;
            successInfo = "身份证照片上传成功";
            // modalDialog.alertType(successInfo, "", "success", false, function() {});
            modalDialog.success(successInfo, "success", false, function() {});
        });
    };
    /**
     * [savePwd description] 保存修改
     * @return {[type]} [description]
     */
    $scope.save = function() {
        $validation.validate($scope.changePwdForm).success(function() {
            var params = {
                logo: $scope.logo,
                accountName: $scope.info.accountName,
                accountDesc: $scope.info.introduction,
                truename: $scope.info.truename,
                email: $scope.info.email,
                idNumber: $scope.info.idNumber,
                idNumberPic: $scope.idNumberPic,
                province: $scope.data.province,
                city: $scope.data.city,
                channelIds: $scope.data.selectedArray + '',
                orgCode: $scope.info.orgCode
            };
            // modalDialog.alertType("是否保存修改的内容？", "保存", "info", true, function() {

            // });
            modalDialog.confirmModal("提交", "提交修改后，该账号需要重新审核在审核期间，APP账号信息显示不变", function() {
                sendtoService(params);
            });
        }).error(function() {
            angular.invalidPosition($scope.changePwdForm, $element);
            /*for (var j in $scope.changePwdForm.$error) {
                $element.find("*[name='" + j + "']").focus();
            }*/
        });

        function sendtoService(params) {
            httpService.http("/mcnww/web/ucenter/pgcUpdateInfo.do", params, "post", true, true).then(function(result) {

                if (result.success) {
                    modalDialog.success("内容修改成功", "success", false, function() {});
                    $scope.$root.$broadcast("pgcSucessLogo", true);
                    $state.go($state.current.name, "", { reload: $state.current.name });
                }else{
                    modalDialog.success(result.message, "success", false,function() {}, function() {},'','everyMonth');
                }

            });
        }
    };
    /**
     * [multipleId description;判读多个id]
     * @param  {[type]} 选中元素的集合
     */
    function multipleId(items, params) {
        if (items.length > 1) {
            var newIds = [];
            for (var i = 0; i < items.length; i++) {
                newIds.push(items[i].id);
            }
            params.ids = newIds.join(',');
        } else {
            params.ids = trsspliceString.spliceString(items, "id", ",");
        }
    }
    /**
     * [accessChannel description] 获取渠道
     * @return {[type]} [description]
     */
    function accessChannel() {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/channel/querychannels.do", "", "get").then(function(data) {
            $scope.data.channelIds = data.data;
            deffer.resolve();
        });
        return deffer.promise;
    };
    /**
     * [getPicSizeLimit description] 获取图片尺寸上限
     * @return {[type]} [description]
     */
    function getPicSizeLimit() {
        httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
            $scope.status.picSizeLimit = data.message;
        });
    }

}]);
